import some from "lodash/some";
import AppContext from "PFApp/app_context";
import { useCallback, useContext, useMemo } from "react";

const ACCESSIBLE_TEMPLATE_PREDICATE = {
  hidden: false,
  create_permitted: true
};

export const useCanCreateActivities = () => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const canCreateActivities = useMemo(
    () => some(currentProfile.templates, ACCESSIBLE_TEMPLATE_PREDICATE),
    [currentProfile.templates]
  );

  const canCreateActivity = useCallback(
    (templateId) => {
      if (!templateId || !canCreateActivities) {
        return false;
      }

      return some(currentProfile.templates, { id: templateId, ...ACCESSIBLE_TEMPLATE_PREDICATE });
    },
    [currentProfile.templates]
  );

  return [canCreateActivities, canCreateActivity];
};
